import React, { useEffect, useState } from "react";
import "./index.scss";
import { imgArr } from "../../assets/images";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  const [isSticky, setIsSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "features", "contact"];
      // const sections = ["home", "features", "screenshots", "contact"];
      const scrollY = window.scrollY;

      for (let i = 0; i < sections.length; i++) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const offsetTop = section.offsetTop - 80; // Adjust if header height is different
          const offsetBottom = offsetTop + section.offsetHeight;
          if (scrollY >= offsetTop && scrollY < offsetBottom) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }

      // Sticky header logic
      const isScrolled = scrollY > 50;
      setIsSticky(isScrolled);

      const header = document.querySelector(".main-header");
      if (window.scrollY > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const scrollToSection = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } }); // navigate to home with section
    } else {
      const el = document.getElementById(id);
      if (el) {
        const headerHeight =
          document.querySelector(".main-header")?.offsetHeight || 80;
        const top =
          el.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top, behavior: "smooth" });
      }
      setMenuOpen(false);
    }
  };

  const renderNavLink = (id, label) => (
    <li>
      <button
        className={activeSection === id ? "active" : ""}
        onClick={() => scrollToSection(id)}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        {label}
      </button>
    </li>
  );

  return (
    <header className={"main-header"}>
      <div
        className="logo"
        onClick={() => {
          navigate("/");
        }}
      >
        <img src={isSticky ? imgArr.logo : imgArr.logoWhite} alt="logo" />
      </div>

      <nav className={`nav`}>
        <ul>
          {renderNavLink("home", "Home")}
          {renderNavLink("features", "Features")}
          {/* {renderNavLink("screenshots", "Screenshots")} */}
          {renderNavLink("contact", "Contact")}
        </ul>
      </nav>

      <div className="toggle" onClick={() => setMenuOpen(!menuOpen)}>
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>

      <div className={`mobile-sidebar ${menuOpen ? "show" : ""}`}>
        <div className="logo">
          <img src={imgArr.logo} alt="logo" />
        </div>
        <ul>
          {renderNavLink("home", "Home")}
          {renderNavLink("features", "Features")}
          {/* {renderNavLink("screenshots", "Screenshots")} */}
          {renderNavLink("contact", "Contact")}
        </ul>
      </div>

      {menuOpen && (
        <div className="overlay" onClick={() => setMenuOpen(false)} />
      )}
    </header>
  );
};

export default Index;
